import * as React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from 'gatsby';

const Header = ({ siteTitle }) => {
  const data = useStaticQuery(
    graphql`
      query MyQuery {
        allContentfulPage (filter: {title: {ne: "Home"}}) {
          nodes {
            title
            slug
          }
        }
      }
    `
  );
  return (
  <header>
    
    <div class="alert">
      <div style={{
        margin: `0 14%`,
        /*maxWidth: `var(--size-content)`,*/
        padding: `0 var(--size-gutter)`
      }}>
        <strong>Site wide alert: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod... [read more]
        <button class="button">Close</button>
      </div>
    </div>

    <div class="utility">
      <div style={{
        margin: `0 12%`,
       /* maxWidth: `var(--size-content)`,*/
        padding: `0 var(--size-gutter)`
      }}>
        <a href="https://www.armadale-wa.altitudelg.com/e-services/start.do">Pay my Rates</a>
        <a href="/contactus">Contact us</a>
        <a href="https://www.armadale-wa.altitudelg.com/e-services/start.do">Change Language</a>
        <a href="https://www.armadale-wa.altitudelg.com/e-services/start.do">Explore Armadale</a>
      </div>
    </div>
    
    <div class="mainNavigation" style={{
      margin: `0 14%`,
      /*margin: `0 auto`*/ 
      /*maxWidth: `var(--size-content)`,*/
      padding: `0 var(--size-gutter)`
    }}>
      <a href="/" title="City of Armadale website homepage"><img src="../images/coa_logo.png" alt="City of Armadale logo" /></a>

      <div className="navMain">
      <ul>

      <li className="post">
              <a href=""><span></span> <span className="business-text"></span></a>
              </li>
      <li className="post">
              <a href=""><span></span> <span className="business-text"></span></a>
              </li>
      <li className="post">
              <a href=""><span></span> <span className="business-text"></span></a>
              </li>
      <li className="post">
              <a href=""><span></span> <span className="business-text"></span></a>
              </li>
      <li className="post">
              <a href=""><span></span> <span className="business-text"></span></a>
              </li>
      <li className="post">
              <a href=""><span></span> <span className="business-text"></span></a>
              </li>
      
          
           <li className="post" >
                <a href="/services"><span>Access</span> <span className="business-text">Services <img className="arrow-img" src="https://images.ctfassets.net/p4i5hqtl4d48/3PDlb0hiFmYkdCOp2cHx65/699bcfbadcdb071a12ed27aad3337138/Arrow_down.png"></img></span></a>
              </li>
              <li className="post">
              <a href=""><span>Facilitate</span> <span className="business-text">Business <img className="arrow-img" src="https://images.ctfassets.net/p4i5hqtl4d48/3PDlb0hiFmYkdCOp2cHx65/699bcfbadcdb071a12ed27aad3337138/Arrow_down.png"></img></span></a>
              </li>
              <li className="post">
              <a href=""><span>About</span> <span className="business-text">Us<img className="arrow-img" src="https://images.ctfassets.net/p4i5hqtl4d48/3PDlb0hiFmYkdCOp2cHx65/699bcfbadcdb071a12ed27aad3337138/Arrow_down.png"></img></span></a>
              </li>
        </ul>
        <div className="btnSearch">
          <button><img src="../images/mag_glass_small.png" alt="Search button" /></button>
        </div>
      </div>
    </div>
    
  </header>
  )
}

export default Header
